import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Authorized from "components/Authorized";
import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import { useCustomFieldGroupsMutations } from "hooks/useCustomFieldGroupsTable";
import CustomFieldGroupModal from "./CustomFieldGroupModal";

const EDIT_ACLS = [ACL_RELATIONSHIPS.customFieldGroup.edit];
const DELETE_ACLS = [ACL_RELATIONSHIPS.customFieldGroup.delete];
const ANY_ACLS = [...EDIT_ACLS, ...DELETE_ACLS];

export function CustomFieldGroupsTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const { remove } = useCustomFieldGroupsMutations({
    onDeleted: () => setDeleteOpen(false),
  });

  return (
    <Authorized permissions={ANY_ACLS} partialMatch>
      <>
        <DropdownMenu>
          <DropdownMenuTrigger
            aria-label="Custom field group actions"
            className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
          >
            <Ellipsis />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="tw:w-auto">
            <Authorized permissions={EDIT_ACLS}>
              <DropdownMenuItem onClick={() => setEditOpen(true)}>
                <Pencil />
                Edit
              </DropdownMenuItem>
            </Authorized>
            <Authorized permissions={DELETE_ACLS}>
              <DropdownMenuItem
                variant="destructive"
                onClick={() => setDeleteOpen(true)}
              >
                <Trash2 />
                Delete
              </DropdownMenuItem>
            </Authorized>
          </DropdownMenuContent>
        </DropdownMenu>
        <Authorized permissions={EDIT_ACLS}>
          <CustomFieldGroupModal
            model={original}
            open={editOpen}
            onOpenChange={setEditOpen}
          />
        </Authorized>
        <Authorized permissions={DELETE_ACLS}>
          <ConfirmDeleteDialog
            open={deleteOpen}
            onOpenChange={setDeleteOpen}
            title="Delete Custom Field Group?"
            description="Are you sure you want to delete this Custom Field Group?"
            onConfirm={() => remove.mutate(original.id)}
          />
        </Authorized>
      </>
    </Authorized>
  );
}
